<template>
  <div>
    <div class="vx-row" v-show="loading">
      <div id="loading" class="vs-con-loading__container"></div>
    </div>

    <div v-show="!subscriptions.length && !loading" class="text-center pt-5">
      <p class="text-grey">Você não possui nenhum plano vip.</p>

      <a :href="`${appLinkPlanosMobile}`" rel="noopener">
        <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief mt-3 mr-2">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-mobile"></i> Ver Planos {{ appName }}</span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
        </button>
      </a>

      <a href="/checkout/payment?productId=3" rel="noopener" v-if="appName == 'wSpy Pro'">
        <button name="button" class="vs-component vs-button vs-button-primary vs-button-relief mt-3 ml-2">
          <span class="vs-button-text vs-button--text"> <i class="fas fa-desktop"></i> Ver Planos Netspy Cloud</span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
        </button>
      </a>
    </div>
    <div class="vx-row" v-show="subscriptions.length">
      <div class="vx-col w-full mb-4">
        <h1>Planos VIP</h1>
      </div>

      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-for="subscription in subscriptions" :key="subscription.id">
        <!--<div v-if="!subscription.paypal_subscription_id.length">
        <div v-show="subscription.stripe_subscription_id && appName != 'spyou cloud'" class="bg-danger" style="color: aliceblue; padding:10px;"> Caro cliente, notamos que sua assinatura é do Stripe, infelizmente não trabalhamos mais com essa empresa. Portanto, pedimos por gentileza para que efetue a troca para o PayPal, pelo botão abaixo

              <a href="https://cloud.wtsoftware.com.br/checkout/payment?planId=14" target="_blank">
              <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief w-full mt-6">
              <span class="vs-button-text vs-button--text">
              <svg class="svg-inline--fa fa-eye fa-w-18 vs-icon notranslate icon-scale null" aria-hidden="true" focusable="false" data-prefix="far" data-icon="eye" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg="">
              <path fill="currentColor" d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path></svg>&nbsp;
                    Trocar Cartão
              </span><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
              </button>
              </a>
              </div>
       </div>-->
        <vx-card class="p-2">
          <div><strong>Identificador</strong></div>
          <div class="mb-4">
            {{ subscription.paypal_subscription_id || subscription.stripe_subscription_id || subscription.iugu_subscription_id || subscription.pagarme_subscription_id || subscription.mercadopago_subscription_id || subscription.pagseguro_subscription_id || subscription.galaxpay_subscription_id }}-{{ subscription.id }}
          </div>

          <div><strong>Situação</strong></div>
          <div class="mb-4">{{ subscription.status }}</div>

          <div><strong>Data de Início</strong></div>
          <div class="mb-4">{{ subscription.created_at | formatDate }}</div>

          <div><strong>Renova Em</strong></div>
          <div v-if="subscription.renew_at">{{ subscription.renew_at | formatDate }}</div>
          <div v-else>--/--/----</div>

          <div class="mt-4"><strong>Dispositivo</strong></div>
          <div v-if="subscription.mobile && subscription.mobile.alias">{{ subscription.mobile.alias }} ({{ subscription.mobile.device }})</div>
          <div v-else-if="subscription.mobile && subscription.mobile.device">{{ subscription.mobile.device }}</div>
          <div v-else>-</div>

          <div v-show="!subscription.mobile" class="bg-danger text-white p-4 rounded mt-4">
            <strong>Atenção:</strong> Esse plano VIP não está ativo em nenhum dispositivo. Clique em Escolher Dispositivo para ativar no dispositivo correto.
          </div>

          <button
            name="button"
            class="vs-component vs-button vs-button-success vs-button-relief w-full mt-6"
            v-show="!subscription.mobile"
            @click="selectDevice(subscription)"
            :disabled="loadingSession"
          >
            <span class="vs-button-text vs-button--text">
              <i class="fas fa-mobile"></i> Escolher Dispositivo</span
            >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>

          <button
            name="button"
            class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
            v-show="subscription.stripe_subscription_id"
            @click="getStripeSession(subscription.stripe_subscription_id)"
            :disabled="loadingSession"
          >
            <span class="vs-button-text vs-button--text">
              <i class="fas fa-arrow-circle-right"></i> Gerenciar Plano VIP</span
            >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>

          <a :href="'https://www.paypal.com/myaccount/autopay/connect/' + subscription.paypal_subscription_id" v-show="subscription.paypal_subscription_id">
            <button
              name="button"
              class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
              :disabled="loadingSession"
            >
              <span class="vs-button-text vs-button--text">
                <i class="fas fa-arrow-circle-right"></i> Gerenciar Plano VIP</span
              >
              <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
            </button>
          </a>

          <button
            name="button"
            class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
            @click="updateIuguSubscription(subscription)"
            v-show="subscription.iugu_subscription_id && subscription.status !== 'Cancelada'"
            :disabled="loadingSession"
          >
              <span class="vs-button-text vs-button--text">
                <i class="fas fa-arrow-circle-right"></i> Gerenciar Plano VIP</span
              >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>

          <button
            name="button"
            class="vs-component vs-button vs-button-danger vs-button-relief w-full mt-6"
            @click="cancelIuguSubscription(subscription)"
            v-show="subscription.iugu_subscription_id && subscription.status !== 'Cancelada'"
            :disabled="loadingSession"
          >
            <span class="vs-button-text vs-button--text">
              <i class="fas fa-times-circle"></i> Cancelar Plano VIP</span
            >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>

          <button
            class="vs-component vs-button vs-button-primary vs-button-relief w-full mt-6"
            v-show="subscription.galaxpay_subscription_id && subscription.status !== 'Cancelada'"
            @click="galaxPayRedirect()"
          >
          <span class="vs-button-text vs-button--text">
            <i class="fas fa-arrow-circle-right"></i> Gerenciar Plano VIP</span
          >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>

          <button
            name="button"
            class="vs-component vs-button vs-button-danger vs-button-relief w-full mt-6"
            @click="cancelGalaxpaySubscription(subscription)"
            v-show="subscription.galaxpay_subscription_id && subscription.status !== 'Cancelada'"
            :disabled="loadingSession"
          >
            <span class="vs-button-text vs-button--text">
              <i class="fas fa-times-circle"></i> Cancelar Plano VIP</span
            >
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      color="success"
      @accept="saveSubscription"
      :active.sync="showActivateSubscription"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      title="Escolher Dispositivo"
    >
      Qual dispositivo você quer vincular à esse plano VIP?<br>

      <vs-table ref="table" :data="mobile">
        <template slot="thead">
          <vs-th class="text-center">&nbsp;</vs-th>
          <vs-th class="text-center">Dispositivo</vs-th>
        </template>

        <template>
          <vs-tr :data="device" :key="index" v-for="(device, index) in mobile">
            <vs-td class="text-center">
              <vs-radio v-model="subscriptionToEdit.uid" :vs-value="device.uid" vs-name="device"></vs-radio>
            </vs-td>
            <vs-td class="text-center text-nowrap">
              <span v-if="device.alias">{{ device.alias }} ({{ device.device }})</span>
              <span v-else>{{ device.device }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="mt-2 bg-danger rounded text-white p-6">
        <strong>Leia com Atenção:</strong><br>
        O prazo de validade do dispositivo continuará o mesmo e será renovado conforme dia da renovação.<br>
        Nenhum prazo adicional será colocado no dispositivo.<br>
        Uma vez escolhido o dispositivo, esse plano VIP não poderá ser alterado pra outro dispositivo.
      </div>
    </vs-prompt>

    <vs-prompt
      color="danger"
      @accept="iuguSubscriptionCancellationConfirm"
      :active.sync="iuguSubscriptionCancellationCheck"
      accept-text="Sim"
      cancel-text="Não"
      title="Confirmação"
    >
      Tem certeza que deseja cancelar a assinatura?<br>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="iuguSubscriptionUpdateConfirm"
      :active.sync="iuguSubscriptionUpdateCheck"
      accept-text="Salvar"
      cancel-text="Cancelar"
      title="Atualizar Cartão de Crédito"
    >
      <div class="bg-primary text-white p-4 rounded mb-4">
        Desative seu bloqueador de Ads se você tiver um instalado e ativado (uBlock, Brave, AdBlock, etc), pois ele interfere com o sistema de segurança de cartão.
      </div>

      <div class="mb-2 mt-6">
        <strong>Dados do Cartão</strong>
      </div>
      <div class="mb-2">
        <vs-input
          class="w-full"
          label="Número do Cartão"
          placeholder="Somente números"
          v-model="card_number"
          v-facade="['#### #### #### ####']"
          tabindex="1"
          required
        />
      </div>
      <div>
        <div class="flex mb-2">
          <div class="w-6/12 mr-4">
            <vs-input
              class="w-full"
              label="Data de Validade (Mês/Ano)"
              placeholder="Somente números (MM/AA)"
              v-model="card_date"
              tabindex="1"
              autocomplete="cc-exp-month"
              v-facade="'##/##'"
              required
            />
          </div>

          <div class="w-6/12">
            <vs-input
              class="w-full"
              label="Código de Segurança (CVV)"
              placeholder="Somente números"
              maxlength="4"
              v-model="card_cvv"
              tabindex="1"
              inputmode="numeric" pattern="[0-9]*"
              autocomplete="cc-csc"
              v-facade="['###', '####']"
              required
            />
          </div>
        </div>
        <div class="mb-2">
          <vs-input
            class="w-full"
            label="Nome que aparece no cartão"
            placeholder="Exatamente como está no cartão"
            v-model="card_name"
            tabindex="1"
            required
          />
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      color="danger"
      @accept="galaxpaySubscriptionCancellationConfirm()"
      :active.sync="galaxpaySubscriptionCancellationCheck"
      accept-text="Sim"
      cancel-text="Não"
      title="Confirmação"
    >
      Tem certeza que deseja cancelar a assinatura?<br>
    </vs-prompt>
  </div>
</template>

<script>
import {facade} from 'vue-input-facade'

/* global Iugu */
export default {
  directives: {facade},
  data() {
    return {
      subscriptions: [],
      loading: true,
      loadingSession: false,
      showActivateSubscription: false,
      subscriptionToEdit: {},
      mobile: [],
      appName: process.env.VUE_APP_NAME,
      appLinkPlanosMobile: process.env.VUE_APP_LINK_PLANOS_MOBILE,
      // Iugu
      iuguAccountId: process.env.VUE_APP_IUGU_ACCOUNT_ID,
      iuguTestMode: process.env.VUE_APP_IUGU_TEST_MODE === 'true',
      iuguSubscription: {},
      iuguSubscriptionUpdateCheck: false,
      iuguSubscriptionCancellationCheck: false,
      // Galaxpay
      galaxpaySubscription: {},
      galaxpaySubscriptionUpdateCheck: false,
      galaxpaySubscriptionCancellationCheck: false,
      card_number: null,
      card_date: null,
      card_cvv: null,
      card_name: null
    }
  },
  mounted: function () {
    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    })

    this.load()

    if (Iugu) {
      Iugu.setAccountID(this.iuguAccountId)
      Iugu.setTestMode(this.iuguTestMode)
    }
  },
  methods: {
    load: function () {
      this.$api
      .get('/api/v1/subscription')
      .then((response) => {
        this.loadingSession = false
        this.loading = false
        this.subscriptions = response.data
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

      // mobile
      this.$api
      .get('/api/v1/mobile/device')
      .then((response) => {
        this.mobile = response.data.data
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    selectDevice: function (subscription) {
      this.subscriptionToEdit = subscription
      this.subscriptionToEdit.uid = ''

      this.showActivateSubscription = true
    },
    getStripeSession: function (subscription_id) {
      this.loadingSession = true

      this.$api
      .post('/api/v1/subscription/stripe', {
        subscription_id: subscription_id
      })
      .then((response) => {
        window.location.href = response.data.url
      })
      .catch((error) => {
        this.loadingSession = false

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    updateIuguSubscription: function (subscription) {
      this.iuguSubscription = subscription
      this.iuguSubscriptionUpdateCheck = true
    },
    iuguSubscriptionUpdateConfirm: function () {
      this.loadingSession = true;

      const card_number = this.card_number.replace(/[^0-9]/g, '');
      const firstname = this.card_name.substring(0, this.card_name.indexOf(' ')).trim()
      const lastname = this.card_name.substring(this.card_name.indexOf(' ') + 1).trim()
      const month = this.card_date.split('/')[0]
      const year = "20" + this.card_date.split('/')[1]
      const cc = Iugu.CreditCard(
        card_number,
        month,
        year,
        firstname,
        lastname,
        this.card_cvv
      )

      Iugu.createPaymentToken(cc, response => {
        if (response.errors) {
          this.iuguSubscriptionUpdateCheck = true

          this.$vs.notify({
            time: 6000,
            text: 'Ocorreu um erro ao atualizar seus dados. Verifique se o número do cartão e os demais dados estão corretos.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else {
          this.$api
          .patch('/api/v1/subscription/iugu', {
            subscription_id: this.iuguSubscription.iugu_subscription_id,
            token: response.id
          })
          .then(() => {
            this.iuguSubscriptionUpdateCheck = false

            this.$vs.notify({
              time: 6000,
              text: "Plano VIP alterado com sucesso.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
            });
          })
          .catch((error) => {
            this.iuguSubscriptionUpdateCheck = true

            this.loadingSession = false;

            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: error.response.data.error || error.response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          });
        }
      })
    },
    cancelGalaxpaySubscription: function (subscription) {
      this.galaxpaySubscription = subscription
      this.galaxpaySubscriptionCancellationCheck = true
    },
    galaxpaySubscriptionCancellationConfirm: function () {
      this.loadingSession = true

      this.$api
      .delete('/api/v1/subscription/galaxpay/cancel/' + this.galaxpaySubscription.galaxpay_subscription_id)
      .then(() => {
        this.load()

        this.$vs.notify({
          time: 6000,
          text: 'Plano VIP cancelado com sucesso.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
      .catch((error) => {
        this.loadingSession = false

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    cancelIuguSubscription: function (subscription) {
      this.iuguSubscription = subscription
      this.iuguSubscriptionCancellationCheck = true
    },
    iuguSubscriptionCancellationConfirm: function () {
      this.loadingSession = true

      this.$api
      .delete('/api/v1/subscription/iugu/cancel/' + this.iuguSubscription.iugu_subscription_id)
      .then(() => {
        this.load()

        this.$vs.notify({
          time: 6000,
          text: 'Plano VIP cancelado com sucesso.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
      .catch((error) => {
        this.loadingSession = false

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    saveSubscription: function () {
      this.loadingSession = true

      this.$api
      .patch('/api/v1/subscription/update', {
        uid: this.subscriptionToEdit.uid,
        subscription_id: this.subscriptionToEdit.id
      })
      .then(() => {
        this.load()

        this.$vs.notify({
          time: 6000,
          text: 'Plano VIP vinculado com sucesso ao dispositivo.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      })
      .catch((error) => {
        this.loadingSession = false

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    galaxPayRedirect() {
      window.open(process.env.VUE_APP_GALAXPAY_CUSTOMER_URL)
    }
  }
}
</script>

<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }

  .demo-basic-card a {
    color: #fff !important;
  }
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.superior {
  width: auto;
  height: auto;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #fff;
  z-index: 1000;
  padding: 1rem;
}

.background {
  width: 100%;
  height: 100%;
}
</style>
